import { render, staticRenderFns } from "./PageConfigurations.vue?vue&type=template&id=07a9639b&scoped=true"
import script from "./PageConfigurations.vue?vue&type=script&lang=js"
export * from "./PageConfigurations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a9639b",
  null
  
)

export default component.exports